import React, { FC } from "react";
import { useParams } from "react-router-dom";

import { useApisManagersMeetingNotesEdit } from "~/hooks";

import {
  EmployeeLayout,
  EmployeeLayoutMainContent,
  EmployeeLayoutRightSidebar,
} from "~/components/layouts";
import { ManagersMeetingNoteForm } from "~/components/organisms";
import { NotFoundIndex } from "~/components/pages";

export const ManagersMeetingNotesEdit: FC = () => {
  const { id = "" } = useParams<{ id: string }>();
  const { data, isError } = useApisManagersMeetingNotesEdit({
    id,
  });

  const breadCrumbItems = [
    { label: "1on1・MTG", href: "/managers/meeting_notes" },
    { label: "編集", href: `/managers/meeting_notes/${id}/edit` },
  ];

  if (isError) return <NotFoundIndex />;

  return (
    <EmployeeLayout withRightSidebar breadCrumbItems={breadCrumbItems}>
      <EmployeeLayoutMainContent withRightSidebar>
        {data && (
          <ManagersMeetingNoteForm
            meetingNote={data.meetingNote}
            selectableEmployees={data.selectableEmployees}
          />
        )}
      </EmployeeLayoutMainContent>
      <EmployeeLayoutRightSidebar />
    </EmployeeLayout>
  );
};
